<template>
    <div class="container">
        <div v-if="loading" class="text-center">
            <i class="fa fa-spinner fa-spin fa-4x"></i>
        </div>
        <div v-else="">
            <h1 class="page-header">{{c.title}} <small v-if="p !== null"> &raquo; {{p.title}}</small></h1>
            <div class="row">
                <div class="col-sm-3">
                    <div class="list-group">
                        <router-link class="list-group-item" v-for="pg in c.pages" :class="{active: pg.slug === page}" :to="'/' + c.slug + '/' + pg.slug" :key="pg.id">{{pg.title}}</router-link>
                    </div>
                </div>
                <div v-if="p !== null" class="col-sm-9" v-html="p.content"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'page-view',
        props: {
            category: {default: ''},
            page: {default: ''},
        },
        data() {
            return {
                c: null,
                p: null,
                loading: true,
            }
        },
        watch: {
            category() {
                this.refresh();
            },
            page() {
                this.refresh();
            }
        },
        methods: {
            refresh() {
                this.loading = true;
                this.$http.get('/api/page-view/' + this.category + '/' + this.page).then(response => {
                    this.c = response.data.category;
                    this.p = response.data.page;
                    this.loading = false;
                });
            }
        },
        mounted() {
            this.refresh();
        }
    }
</script>